import { render, staticRenderFns } from "./IconFileXls.vue?vue&type=template&id=e6e9553a&scoped=true&"
import script from "./IconFileXls.vue?vue&type=script&lang=js&"
export * from "./IconFileXls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e9553a",
  null
  
)

export default component.exports